

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VisibilitaFascicoloDTO } from "../dto/visibilita-fascicoloDTO";
import { VisibilitaFascicoloVO } from "../vo/visibilita-fascicoloVO";
import { MapperUtente } from "./mapper-utente";




@Injectable({
    providedIn: "root"
})
export class MapperVisibilitaFascicolo implements MapperInterface<VisibilitaFascicoloDTO, VisibilitaFascicoloVO> {
    constructor(
        private mapperUtente: MapperUtente
    ) {

    }
    convertVoToDto(vo: VisibilitaFascicoloVO): VisibilitaFascicoloDTO {
        if (vo != null) {
            const dto = new VisibilitaFascicoloDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.dataFineVisibilita = vo.dataFineVisibilita;
            dto.dataInizioVisibilita = vo.dataInizioVisibilita;
            dto.operatore = this.mapperUtente.convertVoToDto(vo.operatore);
            dto.utente = this.mapperUtente.convertVoToDto(vo.utente);
            dto.tipoVisibilita = vo.tipoVisibilita;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: VisibilitaFascicoloDTO): VisibilitaFascicoloVO {
        if (dto != null) {
            const vo = new VisibilitaFascicoloVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.dataFineVisibilita = dto.dataFineVisibilita;
            vo.dataInizioVisibilita = dto.dataInizioVisibilita;
            vo.operatore = this.mapperUtente.convertDtoToVo(dto.operatore);
            vo.utente = this.mapperUtente.convertDtoToVo(dto.utente);
            vo.tipoVisibilita = dto.tipoVisibilita;
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: VisibilitaFascicoloVO[]): VisibilitaFascicoloDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: VisibilitaFascicoloDTO[]): VisibilitaFascicoloVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
